<template>
  <li class="switcher">
    <div v-if="thereAreImages" class="d-none d-md-block">
      <figure class="m-0">
        <img
          v-show="!switchOnAnnual"
          v-bind="commonImgProps"
          :src="leftImage.url"
          :alt="leftImage.alt"
        />
        <img
          v-show="switchOnAnnual"
          v-bind="commonImgProps"
          :src="rightImage.url"
          :alt="rightImage.alt"
        />
      </figure>
    </div>
    <SwitchPlan
      class="m-0"
      v-bind="switchProps"
      :switch-on-annual="switchOnAnnual"
      @switch-plans="handleSwitch"
    >
      <template #left-text>{{ leftText }}</template>
      <template #right-text>{{ rightText }}</template>
    </SwitchPlan>
  </li>
</template>
<script>
import SwitchPlan from '@/components/PurchaseFlow/Plans/SwitchPlan';
export default {
  components: { SwitchPlan },
  props: {
    leftImage: {
      type: Object,
      required: false,
      default: null,
      validator: (leftImage) => 'url' in leftImage
    },
    leftText: {
      type: String,
      required: true
    },
    rightImage: {
      type: Object,
      required: false,
      default: null,
      validator: (rightImage) => 'url' in rightImage
    },
    rightText: {
      type: String,
      required: true
    },
    switchOnAnnual: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    switchProps() {
      return {
        activePillColor: 'var(--primary-color)',
        activePillTextColor: 'var(--white)'
      };
    },
    thereAreImages() {
      return this.leftImage && this.rightImage;
    },
    commonImgProps() {
      return {
        width: 250,
        height: 200,
        loading: 'lazy'
      };
    }
  },
  methods: {
    handleSwitch(value) {
      this.$emit('switch', value);
    }
  }
};
</script>
<style lang="scss" scoped>
.switcher {
  display: grid;
  align-content: start;
  font-size: 13px;
  figure {
    margin: 0;
    display: flex;
    justify-content: center;
  }
  figure img {
    object-fit: contain;
    border-top-left-radius: var(--border-radius);
  }
}
</style>
